/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_wizard_review_spending_mode = /** @type {(inputs: {}) => string} */ () => {
	return `Modo de gasto`
};

const en_cards_wizard_review_spending_mode = /** @type {(inputs: {}) => string} */ () => {
	return `Spending mode`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_wizard_review_spending_mode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_wizard_review_spending_mode(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_wizard_review_spending_mode", locale)
	if (locale === "es") return es_cards_wizard_review_spending_mode(inputs)
	return en_cards_wizard_review_spending_mode(inputs)
};
export { cards_wizard_review_spending_mode as "cards.wizard.review_spending_mode" }